import support from './supporter'
import eventHelper from './eventHelper'
/**
 *  @params
 *  protocol = {
 *       intent
 *       schema
 *       yingyongbao
 *       universalLink
 *    }
 * timeout 唤起失败的延迟时间
 * fail 失败的回掉
 *
 * @methods
 * call 唤起
 */

/**
 * 唤起app
 * @param {object=} options - 配置项
 * @class CallApp
 */

const SYMBOL = {
    intent: 'intent',
    schema: 'schema',
    yingyongbao: 'yingyongbao',
    universalLink: 'universalLink'
};

class CallApp {
    constructor(option) {
        this.protocol = {
            intent: option.protocol.intent,
            schema: option.protocol.schema,
            yingyongbao: option.protocol.yingyongbao,
            universalLink: option.protocol.universalLink
        }
        this.failCallback = option.fail;
        this.timeout = 2500;
    }

    /**
     * 唤起
     */
    call() {
        let protocolKey = this._selectProtocol();
        let protocolUrl = this.protocol[protocolKey];
        if (protocolKey !== SYMBOL.universalLink) {
            this._handlelaunchApp();
        }
        window.location = protocolUrl;
    }

    /**
     * 获取应该使用的唤端媒介
     * @returns string - schema、intent、UniversalLink
     */
    _selectProtocol() {
        let protocolKey = SYMBOL.schema;
        /* 特殊处理：微信使用应用宝 */
        if (support.isWeixin) {
            return SYMBOL.yingyongbao;
        }

        /* 安卓 */
        if (support.os.android) {
            /* intent: 安卓端的chrome25+ 不需要考虑25以下的版本（发布时间为2013年2月）*/
            if (support.isChrome) {
                protocolKey = SYMBOL.intent;
            }
        }
        /* 苹果 */
        else if (support.os.ios) {
            /* qq浏览器与ios9以下使用schema */
            if (support.isQQ || support.os.versionMajor < 9) {
                protocolKey = SYMBOL.schema;
            } else {
                /* UniversalLink: ios9+ 支持*/
                protocolKey = SYMBOL.universalLink;
            }
        }
        return protocolKey;
    }

    /**
     *
     * 唤起是否成功
     * @memberof CallApp
     */
    _handlelaunchApp() {
        /* 判断唤起失败的方式：在timeout时间之后document.hidden为true则判断为唤起失败，同时监听页面的visibilitychange事件，触发事件执行clearimeout */
        CallApp.timer = setTimeout(() => {
            const hide = this._isPageHidden();
            if (!hide) {
                clearTimeout(this.timer);
                (typeof this.failCallback === 'function') && (this.failCallback());
            }
        }, this.timeout);
        _addVisibilityEvent(_handleEventFn)
    }

    /**
     * 判断页面是否隐藏（进入后台）
     */
    _isPageHidden() {
        const prefix = _getPagePropertyPrefix();
        if (prefix === false) return false;
        const hiddenProperty = prefix ? `${prefix}Hidden` : 'hidden';
        return document[hiddenProperty];
    }
}

/**
 * 唤起成功后的处理函数
 */
function _handleEventFn() {
    clearTimeout(CallApp.timer);
    CallApp.timer === undefined; // 唤起成功清除Timeout
    _removeVisibilityEvent(_handleEventFn); // 唤起成功清除visibilitychange监听事件
}

/**
 * 监听visibilitychange事件
 */
function _addVisibilityEvent(cb) {
    const prefix = _getPagePropertyPrefix();
    let visibilityChangeProperty = prefix !== false ? `${prefix}visibilitychange` : false;
    if (visibilityChangeProperty) {
        eventHelper.addHandler(document, visibilityChangeProperty, cb);
    } else {
        eventHelper.addHandler(window, 'pagehide', cb);
    }
}

/**
 * 移除visibilitychange事件
 */
function _removeVisibilityEvent(cb) {
    const prefix = _getPagePropertyPrefix();
    let visibilityChangeProperty = prefix !== false ? `${prefix}visibilitychange` : false;
    if (visibilityChangeProperty) {
        eventHelper.removeHandler(document, visibilityChangeProperty, cb);

    } else {
        eventHelper.removeHandler(window, 'pagehide', cb);
    }
}

/**
 * 获取判断页面 显示|隐藏 状态改变的属性
 */
function _getPagePropertyPrefix() {
    const prefixes = ['webkit', 'moz', 'ms', 'o'];
    let correctPrefix;

    if ('hidden' in document) return '';

    prefixes.forEach((prefix) => {
        if (`${prefix}Hidden` in document) {
            correctPrefix = prefix;
        }
    });

    return correctPrefix || false;
}


export default CallApp;